export default {
  computed: {
    acountData() {
      return [
        { name: '公司', level: '1', value: '' },
        { name: '分公司', level: '2', value: '' },
        { name: '大股东', level: '3', value: '' },
        { name: '股东', level: '4', value: '' },
        { name: '总代', level: '5', value: '' },
        { name: '代理', level: '6', value: '' },
        { name: '会员', level: '7', value: '' }
      ]
    }
  },
}